import React from "react"
import { trpc } from "../../lib/trpc"

interface DebugTabProps {
  starredProjectIds: string[]
}

export const DebugTab: React.FC<DebugTabProps> = ({ starredProjectIds }) => {
  const { data: allProjects } = trpc.aiChat.listProjects.useQuery({
    include_archived: true,
  })

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">Starred Project IDs (localStorage)</h3>
        <pre className="bg-secondary p-4 rounded text-xs overflow-auto max-h-48 text-foreground">
          {JSON.stringify(starredProjectIds, null, 2)}
        </pre>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">All Projects (from API)</h3>
        <pre className="bg-secondary p-4 rounded text-xs overflow-auto max-h-96 text-foreground">
          {JSON.stringify(allProjects, null, 2)}
        </pre>
      </div>
    </div>
  )
}
